module.exports = __webpack_public_path__ + "img/index1.86919e09.jpg";